export const CARD_UPDATE_EVENTS = {
  Viewed: 'card update viewed',
  Submitted: 'card update submitted',
  Succeeded: 'card update succeeded',
  Failed: 'card update failed',
} as const

export type CardUpdateSurface =
  | 'decline sheet'
  | 'suspended page'
  | 'suspended banner'
  | 'plan and billing'
